import { createContext, useContext } from "react";

import { mockEventsLabels } from "../../../mocks/mock-event";
import { Event, EventsLabels, EventSubscription } from "../types";

export interface EventDetailData {
  event?: Event;
  labels: EventsLabels;
  loading?: boolean;
  error?: boolean;
  subscription?: EventSubscription;
}

export const EventDetailContext = createContext<EventDetailData>({
  labels: mockEventsLabels,
});

export const useEventDetail = () => useContext(EventDetailContext);
